import { pushSubscriptions } from '../pushSubscription'
import { describeTable } from './describeTable'

describeTable(pushSubscriptions, {
  hiddenColumns: ['endpoint', 'p256dhKey', 'authKey'],
  description: `One browser/device Web Push registration, tied to a login session (initial_token_id → refresh_tokens); deleted when the session is revoked. Useful only for counting devices with push enabled per session/user (join refresh_tokens for the user).
endpoint, p256dh_key and auth_key are device push credentials and are NOT readable by this role, so SELECT * fails on this table — list columns explicitly (id, initial_token_id, created_at, updated_at, deleted_at).`,
  columns: {
    initialTokenId:
      'First refresh token of the login session that registered the device; join refresh_tokens → users.',
  },
})
